import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PosDeviceDetails } from '@fitness-force/models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DrawerModule } from 'primeng/drawer';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'pos-device-list',
  templateUrl: './pos-device-list.component.html',
  styleUrls: ['./pos-device-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DrawerModule,
    StyleClassModule,
    DialogModule,
    RadioButtonModule,
    ButtonModule,
    TranslateModule
  ]
})
export class PosDeviceListComponent implements OnInit {
  @Input('visible') chargeOnTerminalModal :boolean = false;
  @Input('devices') deviceList = new BehaviorSubject<PosDeviceDetails[]>([]);
  @Input('selecteedDevice') selectdDevice = new BehaviorSubject<PosDeviceDetails[]>([]);

  @Output() closeDevicesPopup: EventEmitter<{hidePopup: boolean;selectedDevice: PosDeviceDetails | null}> = new EventEmitter();
  
  deviceForm: UntypedFormGroup = {} as UntypedFormGroup;
  selectedDevice:any;
  
  constructor( private fb: UntypedFormBuilder) { 
    this.deviceForm = this.fb.group({
      selectedDevice : new UntypedFormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  SelectPosDevice()
  {
    const selectedDevice = this.deviceForm.get('selectedDevice')!.value;
    this.closeDevicesPopup.emit({hidePopup:true,selectedDevice:selectedDevice })
  }

  ClosePosDevice()
  {
    this.closeDevicesPopup.emit({hidePopup:true,selectedDevice:null })
  }

  get selectedDeviceFormControl()
  {
    return this.deviceForm.get('selectedDevice') as UntypedFormControl;
  }

}
